import { render, staticRenderFns } from "./SucceedFour.vue?vue&type=template&id=7bd83df6&scoped=true"
import script from "./SucceedFour.vue?vue&type=script&lang=js"
export * from "./SucceedFour.vue?vue&type=script&lang=js"
import style0 from "./SucceedFour.vue?vue&type=style&index=0&id=7bd83df6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd83df6",
  null
  
)

export default component.exports